import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Home Assistant MQTT Auto-Discovery",
  "path": "/Frequently_Asked_Question/UHD_Home_Assistant_MQTT_Discovery/",
  "dateChanged": "2025-11-25",
  "author": "Mike Polinowski",
  "excerpt": "Home Assistant supports the automatic addition of new devices via MQTT – known as MQTT Discovery. This allows you to automatically add your INSTAR camera as a Home Assistant device!",
  "image": "../FAQ_SearchThumb.png",
  "social": "/images/Search/FAQ_SearchThumb.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_FAQs_white.webp",
  "chapter": "FAQs",
  "faq": "WQHD & UHD Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SEOHelmet title='Home Assistant MQTT Auto-Discovery' dateChanged='2025-11-25' author='Mike Polinowski' tag='INSTAR IP Camera' description='Home Assistant supports the automatic addition of new devices via MQTT – known as MQTT Discovery. This allows you to automatically add your INSTAR camera as a Home Assistant device!' image='/images/Search/FAQ_SearchThumb.png' twitter='/images/Search/FAQ_SearchThumb.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationEN={props.location.pathname} locationDE='/de/Frequently_Asked_Question/UHD_Home_Assistant_MQTT_Discovery/' locationFR='/fr/Frequently_Asked_Question/UHD_Home_Assistant_MQTT_Discovery/' crumbLabel="FAQs" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "home-assistant-mqtt-auto-discovery",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#home-assistant-mqtt-auto-discovery",
        "aria-label": "home assistant mqtt auto discovery permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Home Assistant MQTT Auto-Discovery`}</h1>
    <p>{`Home Assistant supports the automatic addition of new devices via MQTT – known as `}<a parentName="p" {...{
        "href": "https://www.home-assistant.io/integrations/mqtt#mqtt-discovery"
      }}>{`MQTT Discovery`}</a>{`.`}</p>
    <p>{`All you need to do is connect the camera to the same MQTT broker that you have integrated into Home Assistant – that's it!`}</p>
    <p>{`If you are not yet using MQTT, simply follow these easy steps to add the camera to Home Assistant.`}</p>
    <h2 {...{
      "id": "adding-your-camera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#adding-your-camera",
        "aria-label": "adding your camera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Adding your Camera`}</h2>
    <h3 {...{
      "id": "configuring-the-camera-mqtt-broker",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#configuring-the-camera-mqtt-broker",
        "aria-label": "configuring the camera mqtt broker permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Configuring the camera MQTT broker`}</h3>
    <p>{`First, the MQTT broker must be activated in the camera. You can find this configuration in the web interface under `}<a parentName="p" {...{
        "href": "/en/Web_User_Interface/1440p_Series/Smarthome/MQTT/"
      }}>{`Smathome/MQTT`}</a>{`:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/451fce97b46a17a76d1fec29278535f2/30cf6/HA_Auto_Discovery_01.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "93.91304347826086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAATABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAECAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAP/aAAwDAQACEAMQAAAB5l6XTNkKRMCP/8QAGRAAAwADAAAAAAAAAAAAAAAAAQIQABEg/9oACAEBAAEFAlhGLxsz/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAFBABAAAAAAAAAAAAAAAAAAAAMP/aAAgBAQAGPwIf/8QAHBAAAgICAwAAAAAAAAAAAAAAAAERMSGREFFh/9oACAEBAAE/Iasx0tCG8IqzZJLVM9Hx/9oADAMBAAIAAwAAABCj/wA//8QAFhEAAwAAAAAAAAAAAAAAAAAAAREg/9oACAEDAQE/EEI//8QAFREBAQAAAAAAAAAAAAAAAAAAASD/2gAIAQIBAT8QFj//xAAeEAEAAgIBBQAAAAAAAAAAAAABABEhMUFRgbHB8f/aAAgBAQABPxAjaDk2TB9CJ2rrbzPFjV5OyWFpdwK2F7pn2pU//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/451fce97b46a17a76d1fec29278535f2/e4706/HA_Auto_Discovery_01.avif 230w", "/en/static/451fce97b46a17a76d1fec29278535f2/d1af7/HA_Auto_Discovery_01.avif 460w", "/en/static/451fce97b46a17a76d1fec29278535f2/7f308/HA_Auto_Discovery_01.avif 920w", "/en/static/451fce97b46a17a76d1fec29278535f2/85cc3/HA_Auto_Discovery_01.avif 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/451fce97b46a17a76d1fec29278535f2/a0b58/HA_Auto_Discovery_01.webp 230w", "/en/static/451fce97b46a17a76d1fec29278535f2/bc10c/HA_Auto_Discovery_01.webp 460w", "/en/static/451fce97b46a17a76d1fec29278535f2/966d8/HA_Auto_Discovery_01.webp 920w", "/en/static/451fce97b46a17a76d1fec29278535f2/409e5/HA_Auto_Discovery_01.webp 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/451fce97b46a17a76d1fec29278535f2/e83b4/HA_Auto_Discovery_01.jpg 230w", "/en/static/451fce97b46a17a76d1fec29278535f2/e41a8/HA_Auto_Discovery_01.jpg 460w", "/en/static/451fce97b46a17a76d1fec29278535f2/4d836/HA_Auto_Discovery_01.jpg 920w", "/en/static/451fce97b46a17a76d1fec29278535f2/30cf6/HA_Auto_Discovery_01.jpg 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/451fce97b46a17a76d1fec29278535f2/4d836/HA_Auto_Discovery_01.jpg",
              "alt": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "title": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Check the client settings in the next tab here:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/30cf6/HA_Auto_Discovery_02.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAOABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAIBAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABzGRkgpD/xAAXEAADAQAAAAAAAAAAAAAAAAABAhAA/9oACAEBAAEFAlhGW//EABURAQEAAAAAAAAAAAAAAAAAABAR/9oACAEDAQE/AYf/xAAVEQEBAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPwGn/8QAFBABAAAAAAAAAAAAAAAAAAAAIP/aAAgBAQAGPwJf/8QAGhABAQEAAwEAAAAAAAAAAAAAAQARITGx8f/aAAgBAQABPyHq2h8gXj2WDaW3/9oADAMBAAIAAwAAABD8/wD/xAAVEQEBAAAAAAAAAAAAAAAAAAAQIf/aAAgBAwEBPxCj/8QAFhEBAQEAAAAAAAAAAAAAAAAAARBB/9oACAECAQE/EBZP/8QAHBABAQEAAQUAAAAAAAAAAAAAAREAMSFRcYGR/9oACAEBAAE/EJag9Tkyrgvhk6Z3vJx031lWt+ahYu//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/e4706/HA_Auto_Discovery_02.avif 230w", "/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/d1af7/HA_Auto_Discovery_02.avif 460w", "/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/7f308/HA_Auto_Discovery_02.avif 920w", "/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/85cc3/HA_Auto_Discovery_02.avif 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/a0b58/HA_Auto_Discovery_02.webp 230w", "/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/bc10c/HA_Auto_Discovery_02.webp 460w", "/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/966d8/HA_Auto_Discovery_02.webp 920w", "/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/409e5/HA_Auto_Discovery_02.webp 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/e83b4/HA_Auto_Discovery_02.jpg 230w", "/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/e41a8/HA_Auto_Discovery_02.jpg 460w", "/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/4d836/HA_Auto_Discovery_02.jpg 920w", "/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/30cf6/HA_Auto_Discovery_02.jpg 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/jpeg"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/53ccd1bb78ffd149b4f5b04d69d6985b/4d836/HA_Auto_Discovery_02.jpg",
              "alt": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "title": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Here you can see the MQTT Discovery prefix – this is already set to homeassistant. If you have stored a different prefix for `}<a parentName="p" {...{
        "href": "https://www.home-assistant.io/integrations/mqtt#mqtt-discovery"
      }}>{`MQTT Discovery`}</a>{` in Home Assistant, you must adjust this accordingly here.`}</p>
    <h3 {...{
      "id": "configuring-the-mqtt-client-in-home-assistant",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#configuring-the-mqtt-client-in-home-assistant",
        "aria-label": "configuring the mqtt client in home assistant permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Configuring the MQTT client in Home Assistant`}</h3>
    <p>{`Now add an `}<a parentName="p" {...{
        "href": "https://www.home-assistant.io/integrations/mqtt"
      }}>{`MQTT integration`}</a>{` in Home Assistant:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/7b1dc/HA_Auto_Discovery_03.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "78.26086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAIAAACZeshMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB30lEQVQoz22Tu46cMBRA6WcH4yfX+AG2sQ0DrGb+IilTREra9Pn/NgJr0Gx2j1wA0vF9UimlrLF93wshKKWcM0IIES3uNOZCCAEAlNKu6yilANC2LSGEHlTGGCllecEYi4OGsv0wjl8gT5qDuq4rrTV9Uq4khHDGjNGMUsYY5xwhdP3I28EeWXBe5LZtxxiXZTHGGGuV1urAGJNSQghdLpe3F3YZAEo+AOC9DyFYaw/dlgfnXAihaZr/ZWttiUwIkVKmlMZxTCnlJymlaZq891/IxhjGWJEB4PF43O/3eZ7zR8Zx/ELWWkspS6sAIOe8rus0TSVgjHEYnHNuGHrBOUaoHIJQfb1WQgj+kva2bSXz+EL5MgyDUqo0qFxUvU4IAG632zzP05N5nmOMIYzOec45O9h3idEG1dXrkAFgXdeccwhh/Ij3vj0y5JQKSltKUf1J3rZtWZacc4l/ys65Mjyjte17AKg/y2U2Z7UhBO99TDmmXBI+u4Mxrs4ydlnK7X5ftvf5tszLOi9LzFOapuyHaNXZ171hQiCEKm2M7Yf9X6EUpDRaWaPLbtl+31ApePftp/zxxxzbWoIzxnYZ+dxYj7XFZuCyUy50dpAA8kAp7Yxqv/8Sv/8ygs8ai/wPZnthj6VFrCAAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/e4706/HA_Auto_Discovery_03.avif 230w", "/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/d1af7/HA_Auto_Discovery_03.avif 460w", "/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/7f308/HA_Auto_Discovery_03.avif 920w", "/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/85cc3/HA_Auto_Discovery_03.avif 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/a0b58/HA_Auto_Discovery_03.webp 230w", "/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/bc10c/HA_Auto_Discovery_03.webp 460w", "/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/966d8/HA_Auto_Discovery_03.webp 920w", "/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/409e5/HA_Auto_Discovery_03.webp 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/81c8e/HA_Auto_Discovery_03.png 230w", "/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/08a84/HA_Auto_Discovery_03.png 460w", "/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/c0255/HA_Auto_Discovery_03.png 920w", "/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/7b1dc/HA_Auto_Discovery_03.png 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/bbdb26c45fc21e84ea3e81a1d74040fc/c0255/HA_Auto_Discovery_03.png",
              "alt": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "title": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`The data here is what you previously stored in the camera for the MQTT broker – the camera's IP address, MQTT port and broker login.`}</p>
    <h3 {...{
      "id": "adding-the-detected-device",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#adding-the-detected-device",
        "aria-label": "adding the detected device permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Adding the detected device`}</h3>
    <p>{`What happens next was somewhat inconsistent in my tests. Ideally, you will immediately see that a new device has been found via MQTT:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/db8b63ef69278dd8a3b831e501d31b22/7b1dc/HA_Auto_Discovery_04.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "78.26086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAIAAACZeshMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB5UlEQVQoz3WSz27bMAyHfW4bSyQl6h8l22niJEu6tMCGbuc92A57jl32pIOspmuR7oMOBqxP/Ilil1LKuQylMDMRGWMREdlBFLDMzN57IgoxEpH33jmHiLTQ5ZxDCItmqsWOmYGMNhbaQVdorQGg7/tORIwxRISIAEAXYgy1wlJk9RF3d3dVttYuNbkdTERJZDfP0b8kbFuvqXII4a0MANYHlqJ9QgBEvF34QC6l8FKZFs05J5LzOPEw0TTX/vgKAFz7tWHtzu3aueR5N386HB5Op816EpGU0vF4DCHc3Nz8NzYRAULxZSvbaT0lkST/CN4bRFCqLVSqX606XqhPRUah2vL2eXo+fT4N7yki63GMKXnva4OsBaW6lrbFBoBc8vnpfD6fd7vd/oXDfr+PMRGRNRWsH6RV39EbtNZDGR5OD4dX9vvDdnOYNylGJrLLYiJHpPr3cq2c8zzP9431+n7e3T99XT9+ycOQcy6liEgpxXvfX8shhtSQnNi47z/k15/087d5/Eb9Ci+PEmPUWnemcZEdOefqeNsGO5QR82CdbxvbFDGzUqqTXMo4Ou9w+THeDuITO37pIqJRPTsbS86SReQ1Zo2txw3IAFFQClhrXDA+EKG5QMYQOxMiEb7OUkoJAP4Cq21WlMfAgtEAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/db8b63ef69278dd8a3b831e501d31b22/e4706/HA_Auto_Discovery_04.avif 230w", "/en/static/db8b63ef69278dd8a3b831e501d31b22/d1af7/HA_Auto_Discovery_04.avif 460w", "/en/static/db8b63ef69278dd8a3b831e501d31b22/7f308/HA_Auto_Discovery_04.avif 920w", "/en/static/db8b63ef69278dd8a3b831e501d31b22/85cc3/HA_Auto_Discovery_04.avif 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/db8b63ef69278dd8a3b831e501d31b22/a0b58/HA_Auto_Discovery_04.webp 230w", "/en/static/db8b63ef69278dd8a3b831e501d31b22/bc10c/HA_Auto_Discovery_04.webp 460w", "/en/static/db8b63ef69278dd8a3b831e501d31b22/966d8/HA_Auto_Discovery_04.webp 920w", "/en/static/db8b63ef69278dd8a3b831e501d31b22/409e5/HA_Auto_Discovery_04.webp 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/db8b63ef69278dd8a3b831e501d31b22/81c8e/HA_Auto_Discovery_04.png 230w", "/en/static/db8b63ef69278dd8a3b831e501d31b22/08a84/HA_Auto_Discovery_04.png 460w", "/en/static/db8b63ef69278dd8a3b831e501d31b22/c0255/HA_Auto_Discovery_04.png 920w", "/en/static/db8b63ef69278dd8a3b831e501d31b22/7b1dc/HA_Auto_Discovery_04.png 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/db8b63ef69278dd8a3b831e501d31b22/c0255/HA_Auto_Discovery_04.png",
              "alt": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "title": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`If this does not happen immediately, simply wait a moment – Home Assistant will display a notification in the bottom left corner as soon as the device has successfully logged in. The rest of the process is then identical:`}</p>
    <p>{`The camera's full MQTT interface is now available to you in Home Assistant – including the new `}<a parentName="p" {...{
        "href": "/en/Frequently_Asked_Question/UHD_AI_for_your_Smarthome/"
      }}>{`AI integration`}</a>{`:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/1027e1f44e9e4dbd68651765df11f4ae/a0b80/HA_Auto_Discovery_05.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "88.69565217391305%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAIAAADUsmlHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACYklEQVQ4y3VTy3LUMBDcPyDesFpLoxm935a9GyDhQFX4/6+iZCdUQaAPPqimpe6e9qmU0lrrvRutpZSKSILMOVtrAUB+AIxTEEIAwKm1FkJARCKaOT+z6+P/cX48s88suhhjZIydSimIeNx65Xya+XnHGH3HTns8nx+n8ySY+PHtx+vP13meT7VWpRQAqAFal+V221JKsGPb1m3bEBFBCM7Xtfe1s+uFMXa5XIZs7x0AjAmk1pq1ZgwDCJA2pBgDALD+RSBut/vt/tSWjojX63W8rLU6skHEZVlSSoi4RyKV8cH7GGO6fxEg+3prfXMhK6WH51orER45IuJ630op3getNReCtEkptVKe1oVz7mNyIRnriOgtMO/928sgq82l5BCCMUYAaOuttegj1S4AWt9SXbRxhDjIesexQpQUbLcxSpBIJABID9061bDduRCptFTakK0NY5fTkerb+kmJus7aCSEQBOdCGVdyDt6lUoUQbVlKqdZ7pXfPf7XHu9EA59zVOC6RtI0haGPBZwGgfNaxkvWI8g/yvi1a17HY3jvFzCVqG3JO1jkMg7zdnpb1ZqxVag/sXfSumuj5+fn7jnVZOBekbRk9dxgL51xKSUhKKUQcJUEarcZ3fgih1uq9RwDOORKlFLU2FAtj7NPDwzRND/t3mqZTXXpfN20MHJ69V0oxxph2866l5GyspVgujP2mvZHZ+nUuXcTKU5PW3XbDMUbfOgeJSDFGUgrDv8h2wEmiEZdSh+eXl5elVs65UjqlZKy1MbGP5NLaUeYj85zz8XsLzmfOrfPbtrXWcvoH+Rdq0ISDagWt+wAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/1027e1f44e9e4dbd68651765df11f4ae/e4706/HA_Auto_Discovery_05.avif 230w", "/en/static/1027e1f44e9e4dbd68651765df11f4ae/d1af7/HA_Auto_Discovery_05.avif 460w", "/en/static/1027e1f44e9e4dbd68651765df11f4ae/7f308/HA_Auto_Discovery_05.avif 920w", "/en/static/1027e1f44e9e4dbd68651765df11f4ae/40093/HA_Auto_Discovery_05.avif 955w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/1027e1f44e9e4dbd68651765df11f4ae/a0b58/HA_Auto_Discovery_05.webp 230w", "/en/static/1027e1f44e9e4dbd68651765df11f4ae/bc10c/HA_Auto_Discovery_05.webp 460w", "/en/static/1027e1f44e9e4dbd68651765df11f4ae/966d8/HA_Auto_Discovery_05.webp 920w", "/en/static/1027e1f44e9e4dbd68651765df11f4ae/1a389/HA_Auto_Discovery_05.webp 955w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/1027e1f44e9e4dbd68651765df11f4ae/81c8e/HA_Auto_Discovery_05.png 230w", "/en/static/1027e1f44e9e4dbd68651765df11f4ae/08a84/HA_Auto_Discovery_05.png 460w", "/en/static/1027e1f44e9e4dbd68651765df11f4ae/c0255/HA_Auto_Discovery_05.png 920w", "/en/static/1027e1f44e9e4dbd68651765df11f4ae/a0b80/HA_Auto_Discovery_05.png 955w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/1027e1f44e9e4dbd68651765df11f4ae/c0255/HA_Auto_Discovery_05.png",
              "alt": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "title": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/971e24e2900c2b887eab6fdfdfeafbf9/7b1dc/HA_Auto_Discovery_06.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "91.73913043478261%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAIAAADUsmlHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB90lEQVQ4y22SUW7bMBBEdYHalGREIrkkV1wuKZNy6kRJEeSrQG7RQ/S31y9kFa6tZP6E5dMMZ1l570sp01RyzsYAAEgpHWKKEZSEe+mLjDHOOQCocs6llPVDa22tZWalVA+ms2jsEDimGG2IGoemFs2NqtPpxCGs/1NKhRDmeY7MYcxAURsXOB7H5DhpNwixr29UeaKcM8ACSynHcXx/f397e/vx+uqd1c5zjBzCOI6IuN/fw0RUSrHWrrERMec8DAMA9H0PFoljIDKX2PUNvMQupaQxXStpmma324lFywkNxg/I5C1F7fAaWwhxOByqaZpSGrXWK9y27f9YQiiHEDPw0YBRUt5MLnC+CBFXfgNLDdazdiiV6rp+CxtjrLVmXfE9vN+LMaWXeSby67S+V7Xu/XrnDfzx8XM+nwIRM1tr/zVxhTdvaBPbEGP5blMx1iqlts4AcM28heu6l9IgGue01n3XfYoNoJRWX7UthCCieZ6fzmdmlvKTMxqIRMF7Axq0bpvmZirAeeJ45ADTU5emevetvjlQuekcn19DOYEPGn3TtvW1FSEAAwUGT/pxNohi8zy78vQwTn1IKh4Vp/ZwuIeJOI4c4HH+wnkAfUwxeA9KLbE3bQ8cApvF+cXgsHX+9fvPmBLi8OWqFucQj0xmen745PwXRnNw2up8nPsAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/971e24e2900c2b887eab6fdfdfeafbf9/e4706/HA_Auto_Discovery_06.avif 230w", "/en/static/971e24e2900c2b887eab6fdfdfeafbf9/d1af7/HA_Auto_Discovery_06.avif 460w", "/en/static/971e24e2900c2b887eab6fdfdfeafbf9/7f308/HA_Auto_Discovery_06.avif 920w", "/en/static/971e24e2900c2b887eab6fdfdfeafbf9/85cc3/HA_Auto_Discovery_06.avif 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/971e24e2900c2b887eab6fdfdfeafbf9/a0b58/HA_Auto_Discovery_06.webp 230w", "/en/static/971e24e2900c2b887eab6fdfdfeafbf9/bc10c/HA_Auto_Discovery_06.webp 460w", "/en/static/971e24e2900c2b887eab6fdfdfeafbf9/966d8/HA_Auto_Discovery_06.webp 920w", "/en/static/971e24e2900c2b887eab6fdfdfeafbf9/409e5/HA_Auto_Discovery_06.webp 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/971e24e2900c2b887eab6fdfdfeafbf9/81c8e/HA_Auto_Discovery_06.png 230w", "/en/static/971e24e2900c2b887eab6fdfdfeafbf9/08a84/HA_Auto_Discovery_06.png 460w", "/en/static/971e24e2900c2b887eab6fdfdfeafbf9/c0255/HA_Auto_Discovery_06.png 920w", "/en/static/971e24e2900c2b887eab6fdfdfeafbf9/7b1dc/HA_Auto_Discovery_06.png 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/971e24e2900c2b887eab6fdfdfeafbf9/c0255/HA_Auto_Discovery_06.png",
              "alt": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "title": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/543624c6f4a17da4c28b9ad23e9250d1/7b1dc/HA_Auto_Discovery_07.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "92.6086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAABuUlEQVQ4y5WS646bMBBG8wSFbY1tmDE2vtskgc2lXfX9H6wym43SQCr1/GR09H2eYRdjHMfxcDgopRBRSomIOWdtDECHUOgARMsRALF8UAuIuBvHMXivlOr7nnNOFihlhBDGW6mddc4bzY8XBkh+fCeENAuEkF1MSQgBAEIISmlVVfVCVX1rKBt8NkaDz/10YQ/TT3YpJYGFT7mu67eFuq4p44NL3jnrQ3f+Tduurqq3B3bjuNda35PXstEafYLpyhi/T29ySlkptSk3lCkbnLU25vl4YA/Tm5xzFkK8qM2ktjFGb01/+rVRu1xFD69qK+28L6+271fK27r+W7bW/uPNUhcxhHCap43ay18Ar7YtdckNIUzTxBh7lvGLDZkyOWjvSvN5nv9TZlwa74sbTtORsVVtsbApNyXZpBi9c+l0YXx1524BXiQr42MIWutm/mg2ThXjPiclewRY31kZH7yXSpkQN94Mpw+xn8GnLoy0g/slv7ZtUwzeu5BHvq4N1nXagDZoHG3bp+TeBhfTYGyZrpNTjDlGBBCIzwtrGtCWD7ZT+ml6k8/Xn/3LbVOZj+p47m0QYkP+A4ehcJN9RBa0AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/543624c6f4a17da4c28b9ad23e9250d1/e4706/HA_Auto_Discovery_07.avif 230w", "/en/static/543624c6f4a17da4c28b9ad23e9250d1/d1af7/HA_Auto_Discovery_07.avif 460w", "/en/static/543624c6f4a17da4c28b9ad23e9250d1/7f308/HA_Auto_Discovery_07.avif 920w", "/en/static/543624c6f4a17da4c28b9ad23e9250d1/85cc3/HA_Auto_Discovery_07.avif 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/543624c6f4a17da4c28b9ad23e9250d1/a0b58/HA_Auto_Discovery_07.webp 230w", "/en/static/543624c6f4a17da4c28b9ad23e9250d1/bc10c/HA_Auto_Discovery_07.webp 460w", "/en/static/543624c6f4a17da4c28b9ad23e9250d1/966d8/HA_Auto_Discovery_07.webp 920w", "/en/static/543624c6f4a17da4c28b9ad23e9250d1/409e5/HA_Auto_Discovery_07.webp 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/543624c6f4a17da4c28b9ad23e9250d1/81c8e/HA_Auto_Discovery_07.png 230w", "/en/static/543624c6f4a17da4c28b9ad23e9250d1/08a84/HA_Auto_Discovery_07.png 460w", "/en/static/543624c6f4a17da4c28b9ad23e9250d1/c0255/HA_Auto_Discovery_07.png 920w", "/en/static/543624c6f4a17da4c28b9ad23e9250d1/7b1dc/HA_Auto_Discovery_07.png 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/543624c6f4a17da4c28b9ad23e9250d1/c0255/HA_Auto_Discovery_07.png",
              "alt": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "title": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/en/static/661b438f982161f4b5ebfd00ef3314bb/7b1dc/HA_Auto_Discovery_08.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "92.6086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAABgklEQVQ4y42T8W4bIQyH8wbcFAIkwJ0PbMCQqO2iVX3/J5vKKVHXcdO+f63v/MP2HUoprbXb7QYAzrllWZxztdYQgv2Ce2CthY5z7tBayykBwDzPxhjZUUpJKbXWiBhj3L5ojDkej1LKU0dKeSjM3ntrrfdeKSWEmDpCiJNSr29v9/udiJxzWutndePAzL7n2eRpmn50pmlS2swBiTCXAgDGmGd149DadXveUF6xpESIVGsdyMwVAPZkwJwSpZRKKVrr73Kt1Xu/FxtiyjnV2nLOg859K+s/YpeciYiZBzIi7r9ZQ6TP3ETj2M8bGMhKQ/w0EXEc+3k6ewPLeb/z/8iIOJZ9Zy/2siJzQcRlWQaxLx07kIUy55BazomZQwhfq49VlXKtDMvsrP3W+aTUDGt+rGo07Z8f/vpqE19yUxc7TeKP2AH7kVQiGslIlxBtiC6SOp//vrDth48xDmQupZbirPXOjd5cY1hTzq21wcDuv97n4bSF0Gcb+eXaKiINp/0b6SNwgPRqg8UAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/661b438f982161f4b5ebfd00ef3314bb/e4706/HA_Auto_Discovery_08.avif 230w", "/en/static/661b438f982161f4b5ebfd00ef3314bb/d1af7/HA_Auto_Discovery_08.avif 460w", "/en/static/661b438f982161f4b5ebfd00ef3314bb/7f308/HA_Auto_Discovery_08.avif 920w", "/en/static/661b438f982161f4b5ebfd00ef3314bb/85cc3/HA_Auto_Discovery_08.avif 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/en/static/661b438f982161f4b5ebfd00ef3314bb/a0b58/HA_Auto_Discovery_08.webp 230w", "/en/static/661b438f982161f4b5ebfd00ef3314bb/bc10c/HA_Auto_Discovery_08.webp 460w", "/en/static/661b438f982161f4b5ebfd00ef3314bb/966d8/HA_Auto_Discovery_08.webp 920w", "/en/static/661b438f982161f4b5ebfd00ef3314bb/409e5/HA_Auto_Discovery_08.webp 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/en/static/661b438f982161f4b5ebfd00ef3314bb/81c8e/HA_Auto_Discovery_08.png 230w", "/en/static/661b438f982161f4b5ebfd00ef3314bb/08a84/HA_Auto_Discovery_08.png 460w", "/en/static/661b438f982161f4b5ebfd00ef3314bb/c0255/HA_Auto_Discovery_08.png 920w", "/en/static/661b438f982161f4b5ebfd00ef3314bb/7b1dc/HA_Auto_Discovery_08.png 956w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/en/static/661b438f982161f4b5ebfd00ef3314bb/c0255/HA_Auto_Discovery_08.png",
              "alt": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "title": "Home Assistant MQTT Discovery INSTAR IP Cameras",
              "loading": "lazy",
              "decoding": "async",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/en/FAQs/"
        }}>{`FAQs`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-9420WQHD/"
            }}>{`IN-9420 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-9408WQHD/"
            }}>{`IN-9408 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-8415WQHD/"
            }}>{`IN-8415 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-8403WQHD/"
            }}>{`IN-8403 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-8401WQHD/"
            }}>{`IN-8401 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-9020FHD/"
            }}>{`IN-9020 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-9010FHD/"
            }}>{`IN-9010 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-9008FHD/"
            }}>{`IN-9008 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-8015FHD/"
            }}>{`IN-8015 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-8003FHD/"
            }}>{`IN-8003 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-8001FHD/"
            }}>{`IN-8001 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-7011HD/"
            }}>{`IN-7011 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-6014HD/"
            }}>{`IN-6014 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-6012HD/"
            }}>{`IN-6012 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-6001HD/"
            }}>{`IN-6001 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-5907HD/"
            }}>{`IN-5907 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/IN-5905HD/"
            }}>{`IN-5905 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/en/FAQs/VGA_Series/"
            }}>{`VGA Series`}</a></li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      